import React from 'react';
import {

	SelectControl,

} from "formik-chakra-ui";

function SelectField(props) {
	const { name, list, title, onChange } = props

	const handleChange = (event) => {
		const selectedValue = event.target.value;
		if (onChange) {
			onChange(selectedValue);
		}

	};
	return (

		<div className="field_section">


			<SelectControl
				name={name}
				label={title}
				onChange={handleChange}
				selectProps={{ placeholder: "Select option" }}
				isRequired={props?.isRequired}
			>
				{list?.data?.map((item) => {
					return (
						<option value={item.id}>{item.name}</option>
					)

				})}

			</SelectControl>
		</div>

	);
}

export default SelectField;